import React from "react";
import Logo from '../../assets/icons/AGROTECH.svg'


const TabReport = () => {
  return (
    <>
      <div className="flex flex-col">
        <label class="block mt-4">
          <span class="text-gray-700 font-bold">Area</span>
          <select class="form-select mt-1 block w-full">
            <option>Pilih kota</option>
            <option>Malang</option>
            <option>Surabaya</option>
          </select>
        </label>
        <label class="block mt-4">
          <span class="text-gray-700 font-bold">Deskripsi</span>
          <textarea
            class="form-textarea mt-1 block w-full"
            rows="3"
            placeholder="Enter some long form content."
          ></textarea>
        </label>
        <label className="block mt-8">
          <buttton className="bg-green-100 text-white font-bold py-4 px-8 rounded mt-8">Simpan</buttton>
        </label>
      </div>
      <div className="flex flex-col ml-auto">
        <label class="block mt-4">
          <span class="text-gray-700 font-bold">Logo</span>
          <img alt="Logo" className="mt-6" src={Logo}/>
        </label>
        <button className="mt-10 p-2 border border-gray-500 bg-white rounded">
<p className="mb-4 mt-2">Unggah foto</p></button>
      </div>
    </>
  );
};

export default TabReport;
